import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  getDepartmentListPath,
  createDepartmentPath,
} from "../../services/config";
import { config } from "../../services/configHeader";
const user = JSON.parse(localStorage.getItem("user_data")) || {}

const accountType = user?.account_type;
const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  depLoading: false,
  depSuccess: false,
  depError: false,
  depMessage: null,

  depGetLoading: false,
  depGetSuccess: false,
  depGetError: false,
  depGetMessage: null,
  depGetData: null,
};


export const fetchDepartmentData = createAsyncThunk(
  "fetchDepartmentData",
  async (userId) => {
    return await axios
      .get(`${baseUrl}${getDepartmentListPath}${userId}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const createDepartment = createAsyncThunk(
  "createDepartment",
  async (data) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };
    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(`${baseUrl}${createDepartmentPath}`, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              let data = {
                response: {
                  data: [],
                  message: "No Internet Connection Found",
                  success: false,
                },
                data: {
                  data: [],
                  message: "No Internet Connection Found",
                  success: false,
                },
              };
              return data;
            } else {
              return error;
            }
          });
  }
);

const departmentSlice = createSlice({
  name: "department",
  initialState,

  reducers: {
    initDepartState: (state) => {
      state.depLoading = false;
      state.depSuccess = false;
      state.depError = false;
      state.depMessage = null;

      state.depGetLoading = false;
      state.depGetSuccess = false;
      state.depGetError = false;
      state.depGetMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchDepartmentData.pending, (state, action) => {
      state.depGetLoading = true;
      state.depGetSuccess = false;
      state.depGetError = false;
      state.depGetMessage = null;
      state.depGetData = null;
    });
    builder.addCase(fetchDepartmentData.fulfilled, (state, action) => {
      const status = action.payload.data.status;
      if (action.payload.status == 200) {
        if (status == true || status == "true") {
          state.depGetLoading = false;
          state.depGetSuccess = true;
          state.depGetError = false;
          state.depGetMessage = action.payload.data.message;
          state.depGetData = action.payload.data.data;
        } else {
          state.depGetLoading = false;
          state.depGetSuccess = false;
          state.depGetError = false;
          state.depGetMessage = action.payload.data.message;
          state.depGetData = null;
        }
      } else {
        state.depGetLoading = false;
        state.depGetSuccess = false;
        state.depGetError = false;
        state.depGetMessage = action.payload.data.message;
        state.depGetData = null;
      }
    });
    builder.addCase(fetchDepartmentData.rejected, (state, action) => {
      state.depGetLoading = false;
      state.depGetSuccess = false;
      state.depGetError = true;
      state.depGetMessage = action.payload.data.message;
      state.depGetData = null;
    });
    // To create department
    builder.addCase(createDepartment.pending, (state, action) => {
      state.depLoading = true;
      state.depSuccess = false;
      state.depError = false;
      state.depMessage = null;
    });
    builder.addCase(createDepartment.fulfilled, (state, action) => {
      state.depLoading = false;
      state.depSuccess = accountType == 2 ? false : true;
      state.depError = accountType == 2 ? true : false;
      state.depMessage = action.payload.data.message;
    });
    builder.addCase(createDepartment.rejected, (state, action) => {
      state.depLoading = false;
      state.depSuccess = false;
      state.depError = true;
      state.depMessage = action.payload.data.message;
    });
  },
});

export const { initDepartState } = departmentSlice.actions;
export default departmentSlice.reducer;
